var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1204_13261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 32.0001C8 32.0001 6 32.0001 6 30.0001C6 28.0001 8 22.0001 16 22.0001C24 22.0001 26 28.0001 26 30.0001C26 32.0001 24 32.0001 24 32.0001H8ZM16 20.1001C17.3261 20.1001 18.5979 19.5733 19.5355 18.6356C20.4732 17.6979 21 16.4262 21 15.1001C21 13.774 20.4732 12.5022 19.5355 11.5646C18.5979 10.6269 17.3261 10.1001 16 10.1001C14.6739 10.1001 13.4021 10.6269 12.4645 11.5646C11.5268 12.5022 11 13.774 11 15.1001C11 16.4262 11.5268 17.6979 12.4645 18.6356C13.4021 19.5733 14.6739 20.1001 16 20.1001Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 2C2.93913 2 1.92172 2.42143 1.17157 3.17157C0.421427 3.92172 0 4.93913 0 6L0 25C0 25.7956 0.31607 26.5587 0.87868 27.1213C1.44129 27.6839 2.20435 28 3 28H4.306C4.72418 26.5302 5.45102 25.1666 6.438 24H2V6C2 5.46957 2.21071 4.96086 2.58579 4.58579C2.96086 4.21071 3.46957 4 4 4H28C28.5304 4 29.0391 4.21071 29.4142 4.58579C29.7893 4.96086 30 5.46957 30 6V24H25.562C26.67 25.308 27.342 26.746 27.694 28H29C29.7956 28 30.5587 27.6839 31.1213 27.1213C31.6839 26.5587 32 25.7956 32 25V6C32 4.93913 31.5786 3.92172 30.8284 3.17157C30.0783 2.42143 29.0609 2 28 2H4Z",
    fill: "#2667B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1204_13261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.1a1288817db4d7fb0e8cb2f3918a0d56.svg";
export { ForwardRef as ReactComponent };